import styles from "../reseller.module.css"

export function CTASection() {
  return (
    <section className={styles.ctaWrapper}>
      <div className={styles.ctaContainer}>
        {/* Background gradient */}
        <div className={styles.ctaBackground}></div>

        {/* Content */}
        <div className={styles.ctaContent}>
          <h2 className={styles.ctaTitle}>Ready to Become a Reseller?</h2>
          <p className={styles.ctaDescription}>
            Join hundreds of successful resellers earning globally. Contact our admin team today to get started!
          </p>

          <div className={styles.ctaButtons}>
            <button className={styles.ctaButtonPrimary} onClick={() => window.location.href = 'https://wa.link/oskfd2'}>Contact Admin</button>
            <button className={styles.ctaButtonSecondary} onClick={() => window.location.href = 'https://wa.link/oskfd2'}>Learn More</button>
          </div>
        </div>
      </div>
    </section>
  )
}
